"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductName = void 0;
var _react = _interopRequireDefault(require("react"));
var _productIndicators = require("./productIndicators");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ProductName = exports.ProductName = function ProductName(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbm-product-name"
  }, props.productHREF ? /*#__PURE__*/_react["default"].createElement("a", {
    href: props.productHREF,
    onClick: props.onClickProductName ? props.onClickProductName : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-description"
  }, props.brandName, " ", props.description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-id"
  }, props.displayId)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: props.textBold ? "product-description" : "product-description product-description-not-bold"
  }, props.brandName, " ", props.description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-id"
  }, props.displayId)), props.qty ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-qty"
  }, "QTY: ", props.qty) : null, /*#__PURE__*/_react["default"].createElement(_productIndicators.ProductIndicators, {
    itemIdentifier: props.itemIdentifier,
    itemIndicators: props.itemIndicators,
    iconSize: props.iconSize
  }), props.allSalesFinal && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.allSalesFinal));
};
//# sourceMappingURL=productName.js.map